module.exports = __webpack_public_path__ + "static/media/leftms.f1e0cca0.png";